<template>
    <x-menu
        offset-y
        open-on-hover
        offset-overflow
        :min-width="itemWidth"
        :max-width="itemWidth"
        :nudge-left="nudgeAmount"
    >
        <template v-slot:activator="{ on }">
            <x-icon color="yellow" :size="size" v-on="on">warning</x-icon>
        </template>

        <div v-for="item in value" class="warning-item">
            {{ itemText ? item[itemText] : item }}
        </div>
    </x-menu>
</template>

<script>
    export default {
        name: 'WarningItems',
        props: {
            value: {
                type: Array
            },
            size: {
                type: [Number, String],
                default: 22
            },
            itemText: {
                type: String
            },
            itemWidth: {
                type: [Number, String],
                default: 106
            }
        },
        computed: {
            nudgeAmount() {
                // used to center the menu to the icon. Vuetify's `auto` property wasn't used as it was aligning incorrectly and set a max height.
                return (this.itemWidth / 2) - (this.size / 2);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .x-menu__content {
        overflow: visible;
        contain: layout;

        &.theme--dark {
            background: transparent;
            border: none;
            box-shadow: none;
        }

        .warning-item {
            background: rgba(27, 28, 29, 0.8);
            border-radius: $border-radius;
            padding: 8px 12px;
            color: $color-secondary;
            font-size: rem(14px);
            font-weight: 400;
            text-align: center;

            + .warning-item {
                margin-top: 5px;
            }
        }
    }

    .x-icon {
        cursor: pointer;
    }
</style>
